'use client';

import { FC, ReactNode } from 'react';

import { StyledContentPageContainer } from './Common.styles';

type Props = {
    children: ReactNode;
};

export const ContentPageContainer: FC<Props> = ({ children }) => {
    return <StyledContentPageContainer>{children}</StyledContentPageContainer>;
};
